import api from "../../services/api";

const path = "v1/portalvideocliente";

export const getPortalVideosCustomers = async (params = "") => {
  return await api.get(`${path}${params}`);
};

export const postPortalVideoCustomer = async ({ cnpj, body }) => {
  return await api.post(`${path}/${cnpj}?qyonHubPost=true`, body);
};
